import classnames from 'classnames'
import { Typography } from 'shared/ui'
import { LINK_PRIVACY_POLICY, LINK_TERMS_CONDITIONS } from 'shared/constants/links'
import styles from './styles.module.scss'

type ITermsAndPolicyProps = {
  className?: string
}

export const TermsAndPolicy = ({ className }: ITermsAndPolicyProps) => {
  return (
    <div className={classnames(styles.wrap, className)}>
      <Typography variant={'body-sm-regular'} ariaLabel={'TermsAndPolicy_text'}>
        {"By continuing, you agree to Salesmsg's"}&nbsp;
        <Typography link variant={'body-sm-medium'} ariaLabel={'TermsAndPolicy_termsLink'}>
          <a className={styles.link} href={LINK_TERMS_CONDITIONS} target='_blank' rel='noreferrer'>
            Terms of Service
          </a>
        </Typography>
        &nbsp;and&nbsp;
        <Typography link variant={'body-sm-medium'} ariaLabel={'TermsAndPolicy_privacyLink'}>
          <a className={styles.link} href={LINK_PRIVACY_POLICY} target='_blank' rel='noreferrer'>
            Privacy Policy
          </a>
        </Typography>
      </Typography>
    </div>
  )
}
